import { render } from "./culinary.vue?vue&type=template&id=0e7372e5&scoped=true"
import script from "./culinary.vue?vue&type=script&lang=js"
export * from "./culinary.vue?vue&type=script&lang=js"

import "./culinary.vue?vue&type=style&index=0&id=0e7372e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e7372e5"

export default script